<div class="modal-content">
  @if (!ecabOrAbove && !authorizedForBuilding) {
  <div class="alert-container">
    {{ 'building.typology.editNotGranted' | transloco }}
  </div>
  } @else {
  <sibat-modal-header [title]="'building.typology.edition' | transloco" (clicked)="closeModal.emit()"> </sibat-modal-header>
  <sibat-typology-editor
    [typology]="building.typology"
    [affectations]="affectations"
    [referringExpert]="building.expert"
    [isEditDenied]="ecabOrAbove"
    (typologyChanged)="save($event.color, $event.affectationKeys, $event.justification)"
  >
  </sibat-typology-editor>
  }
</div>
